import { Helmet } from "react-helmet"
import CTA from "./CTA"
import Hero from "./Hero"
import Navbar from "./Navbar"
import WhyChooseUs from "./WhyChooseUs"
import ViewRooms from "./ViewRooms"
import Testimonial from "./Testimonial"
import HomeFooter from "./HomeFooter"
import Map from "./Map"

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Stay Suite | Find Comfortable Home</title>
        <meta
          name="description"
          content="Stay Suite is a modern apartment and tenant management system that helps landlords manage rooms, tenants, billing, and payments easily. Built for speed, security, and simplicity."
        />
        <meta
          name="keywords"
          content="apartment management system, tenant management, property management software, room rental system, billing system, landlord tools, Stay Suite"
        />
        <meta name="author" content="Stay Suite" />
        <link rel="canonical" href="https://portal-stay-suite.vercel.app" />
      </Helmet>
      <div className="min-h-screen bg-slate-100 w-full">
        <Navbar />
        <Hero />
        <WhyChooseUs />
        <ViewRooms />
        <Testimonial />
        <Map />
        <CTA />
        <HomeFooter />
      </div>
    </>
  )
}
